module.exports = __webpack_public_path__ + "static/media/boss-bar-yellow-05.db0c65e4.png";